const production = {
    host: {
        api: "https://api.cloudplex.megazone.io"     
    }
};

export default production;